import { getProductFormLabel } from '@/lib/productFormData';

/**
 * Honest wording for closest-grade results (flower Grade Order). One place so
 * Search, Buy Requests and offer drafts always say the same thing.
 */
export function closestGradeNotice(requested: string): string {
  const g = getProductFormLabel(requested);
  return `No ${g} right now — here's the closest we have, best match first.`;
}

/** Short label shown on a closest-grade listing row. */
export function closestGradeBadge(): string {
  return 'Closest grade';
}

/** Sentence a seller's offer draft opens with when offering a nearby grade. */
export function closestGradeOfferLine(requested: string, offered: string | null): string {
  const asked = getProductFormLabel(requested);
  const have = offered ? getProductFormLabel(offered) : 'a close grade';
  return `I don't have ${asked} right now, but the closest I have is ${have}.`;
}
